import React, { Component } from "react";
import PropTypes from "prop-types";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

class WebcamCapture extends Component {
  onTakePhoto(dataUri) {
    this.props.handleImageTaken(dataUri);
  }

  render() {
    return (
      <>
        <Camera
          idealFacingMode={"environment"}
          isMaxResolution={true}
          sizeFactor={0.5}
          isFullscreen={true}
          isImageMirror={false}
          onTakePhoto={dataUri => {
            this.onTakePhoto(dataUri);
          }}
        />
        <div
          style={{ bottom: 150 }}
          className="relative m-auto text-white h-full" // z-40
        >
          {this.props.message}
          {/*
            // Terrible attempt at intercepting click.
            <div
            className="relative m-auto"
            onClick={(e) => {
              console.log("clickerino");
              this.props.handleButtonClicked();
              return true;
            }}
            style={{ height: 80, width: 80, top: 35 }}
          ></div>
          */}
        </div>
      </>
    );
  }
}

WebcamCapture.propTypes = {
  message: PropTypes.string,
  handleButtonClicked: PropTypes.func.isRequired
};

WebcamCapture.defaultProps = {
  message: ""
};

export default WebcamCapture;
